const trimValues = (values: any): any => {
  const trimmedValues: any = {};

  for (const key in values) {
    if (typeof values[key] === "string") {
      trimmedValues[key] = values[key]?.trim() || "";
    } else {
      trimmedValues[key] = values[key];
    }
  }

  return trimmedValues;
};

export default trimValues;
